export const isValidUrl = (urlString: unknown): boolean => {
	if (typeof urlString !== 'string') return false;
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};
